import React from "react";

import coming_soon from "../../images/coming_soon.jpeg"

  const Usuarios = () => {

    return (
      <div>
        <img src={coming_soon} alt="logo" style={{width: '100%'}} />
      </div>
    );
  
}

export default Usuarios;